import APP_CONSTANTS from "src/application/shared/app_constants";
import loadCensoredWords from "../loadCensoredWords";

let censored_words_en = new Set([
  "bychara",
  "byk",
  "chernozhopyi",
  "dolboy'eb",
  "ebalnik",
  "ebalo",
  "ebalom sch'elkat",
  "gol",
  "mudack",
  "opizdenet",
  "osto'eblo",
  "ostokhuitel'no",
  "ot'ebis",
  "otmudohat",
  "otpizdit",
  "otsosi",
  "padlo",
  "pedik",
  "perdet",
  "petuh",
  "pidar gnoinyj",
  "pizda",
  "pizdato",
  "pizdatyi",
  "piz'det",
  "pizdetc",
  "pizdoi nakryt'sja",
  "pizd'uk",
  "piz`dyulina",
  "podi ku'evo",
  "poeben",
  "po'imat' na konchik",
  "po'iti posrat",
  "po khuy",
  "poluchit pizdy",
  "pososi moyu konfetku",
  "prissat",
  "proebat",
  "promudobl'adsksya pizdopro'ebina",
  "propezdoloch",
  "prosrat",
  "raspeezdeyi",
  "raspizdatyi",
  "raz'yebuy",
  "raz'yoba",
  "s'ebat'sya",
  "shalava",
  "styervo",
  "sukin syn",
  "svodit posrat",
  "svoloch",
  "trakhat'sya",
  "trimandoblydskiy pizdoproyob",
  "ubl'yudok",
  "uboy",
  "u'ebitsche",
  "vafl'a",
  "vafli lovit",
  "v pizdu",
  "vyperdysh",
  "vzdrochennyi",
  "yeb vas",
  "za'ebat",
  "zaebis",
  "zalupa",
  "zalupat",
  "zasranetc",
  "zassat",
  "zlo'ebuchy",
  "бздёнок",
  "блядки",
  "блядовать",
  "блядство",
  "блядь",
  "бугор",
  "во пизду",
  "встать раком",
  "выёбываться",
  "гандон",
  "говно",
  "говнюк",
  "голый",
  "дать пизды",
  "дерьмо",
  "дрочить",
  "другой дразнится",
  "ёбарь",
  "ебать",
  "ебать-копать",
  "ебло",
  "ебнуть",
  "ёб твою мать",
  "жопа",
  "жополиз",
  "играть на кожаной флейте",
  "измудохать",
  "каждый дрочит как он хочет",
  "какая разница",
  "как два пальца обоссать",
  "курите мою трубку",
  "лысого в кулаке гонять",
  "малофья",
  "манда",
  "мандавошка",
  "мент",
  "муда",
  "мудило",
  "мудозвон",
  "наебать",
  "наебениться",
  "наебнуться",
  "на фиг",
  "на хуй",
  "на хую вертеть",
  "на хуя",
  "нахуячиться",
  "невебенный",
  "не ебет",
  "ни за хуй собачу",
  "ни хуя",
  "обнаженный",
  "обоссаться можно",
  "один ебётся",
  "опесдол",
  "офигеть",
  "охуеть",
  "охуительно",
  "половое сношение",
  "секс",
  "сиськи",
  "спиздить",
  "срать",
  "ссать",
  "траxать",
  "ты мне ваньку не валяй",
  "фига",
  "хапать",
  "хер с ней",
  "хер с ним",
  "хохол",
  "хрен",
  "хуёво",
  "хуёвый",
  "хуем груши околачивать",
  "хуеплет",
  "хуило",
  "хуиней страдать",
  "хуиня",
  "хуй",
  "хуйнуть",
  "хуй пинать",
]);

if (!censored_words_en.keys.length) {
  async () => {
    try {
      censored_words_en = await loadCensoredWords(
        APP_CONSTANTS.CENSORED_WORDS_FETCH_URLS.RU
      );
    } catch (error) {
      throw new Error(`❌ Error loading censored words [RU]! ${error}`);
    }
  };
}

export default censored_words_en;
